import { Component, OnInit } from "@angular/core";
import { ModalController, NavController, NavParams } from "@ionic/angular";
import { AlertandloadingService } from "src/app/services/alertandloading.service";
import { ApiService } from "src/app/services/api.service";

@Component({
  selector: "app-transaction",
  templateUrl: "./transaction.page.html",
  styleUrls: ["./transaction.page.scss"],
})
export class TransactionPage implements OnInit {
  securityCode: string;
  verificationMethod: string = "authenticator";
  wallet_id: number;
  to_address: string;
  from_address: string;
  amount: number;
  symbol: string;

  activeView: string = "send";
  transactionInfo: any;

  constructor(
    private modalCtrl: ModalController,
    private navCtrl: NavController,
    private navParams: NavParams,
    private alertandLoading: AlertandloadingService,
    public api: ApiService
  ) {
    this.wallet_id = this.navParams.get("wallet_id");
    this.to_address = this.navParams.get("to_address");
    this.from_address = this.navParams.get("from_address");
    this.amount = this.navParams.get("amount");
    this.symbol = this.navParams.get("symbol");
  }

  ngOnInit() {
    this.prepareSecurityVerification();
  }

  closeModal() {
    this.modalCtrl.dismiss(this.transactionInfo);
  }

  async submit() {
    if (/^\d{6}$/.test(this.securityCode || "")) {
      let data = {
        wallet_id: this.wallet_id,
        to_address: this.to_address,
        amount: this.amount,
        security_code: this.securityCode,
      };

      this.alertandLoading.presentLoading("sending transaction please wait");

      this.api.transferFiat(data).then(
        (result: any) => {
          this.alertandLoading.dismissLoading();
          if (!result.error) {
            this.transactionInfo = result.data.transaction;
            this.activeView = "result";
          } else {
            this.securityCode = "";
            this.alertandLoading.showAlert("Alert", result.message[0]);
          }
        },
        (error: any) => {
          this.alertandLoading.dismissLoading();
          console.log(error);
        }
      );
    } else {
      this.alertandLoading.showAlert(
        "Verification required",
        "Enter the current 6 digit security code"
      );
    }
  }

  async openTwoFactorSetup() {
    await this.modalCtrl.dismiss();
    this.navCtrl.navigateForward("settings/2fa");
  }

  private prepareSecurityVerification() {
    const enabled = this.api.usersession &&
      (this.api.usersession.two_factor_enabled === true || this.api.usersession.two_factor_enabled == 1);
    this.verificationMethod = enabled ? "authenticator" : "setup";
  }
}
